export default "__VITE_ASSET__C8ON04qX__"